import { PaymentService } from '@app/_services/payment.service';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonUtility } from '@app/_modules/commonUtility';
import { retryWhen } from 'rxjs/operators';
import * as master from '../../assets/master.json';
import * as moment from 'moment';

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import 'moment/min/locales';



@Component({  templateUrl: './pay-student.component.html',

providers: [
    
  {provide: MAT_DATE_LOCALE, useValue: 'locales'},
  {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
  },
  {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
]


})
export class PayStudentComponent implements OnInit {

  
  JSON;
  console;
  todayDate:Date;
  total:any = 0;
  @ViewChild('txnForm') txnForm: any;
      isgPay_url:any;

  submitBtnMsg:String;
  submitBtnMsgClass:String = 'wrappper';
  form: FormGroup;
  form1: FormGroup;
    loading = false;
    submitted = false;
    initialCap: any;
    commonUtility:CommonUtility;
    EncDataField:string;
    MerchantIdField:string;
    TransactionId:string;
    BankIdField:string;
    TerminalIdField:string;
    VersionField:string;
    tranxnForm : FormGroup;
    resStatusCode;
    feeData:any;
    res:any;
    isRecordNotFound:boolean = false;
    totalFee:any;
    totalDisabled:boolean=true;
    studentType:String ;
    studentData:any;
    studentTypeId:any;
    moment:any;
   

  constructor( private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private paymentService:PaymentService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string,

    ) {
      this.commonUtility = paymentService.commonUtility;
      this.isgPay_url = paymentService.isgPay_url;
      moment.updateLocale('es',Location)
    }


  ngOnInit() {
     this.todayDate = new Date();
     this.form = this.formBuilder.group({
    
     });

     this.form = this.formBuilder.group({
   

    });
    this.tranxnForm = this.formBuilder.group({
      Version:[''],
      TerminalId: [''],
      BankId: [''],
      MerchantId: [''],
      EncData:[''],
      TransactionId:['']

           });

    
  }

  redirectHome()
    {
      this.router.navigate(['/']);
    }

    onSubmit(){

    }


hideError(controlName:any)
    {
      this.form.controls[controlName].markAsUntouched();
      if(this.submitBtnMsgClass && this.submitBtnMsgClass.indexOf("alertBlock")>-1)
      {  this.submitBtnMsgClass="wrapper"; }
      if(this.submitBtnMsg && this.submitBtnMsg.indexOf("a")>-1)
      { this.submitBtnMsg=""; }

    }

    
onStudentTypeChange(event){
  this.form.reset();
  this.studentTypeId = event.value;
  if(this.studentTypeId ==1){
    this.form.addControl('schoolBranch', this.formBuilder.control('',Validators.required));
    this.form.addControl('studentClass', this.formBuilder.control('',Validators.required));
    this.form.addControl('studentName', this.formBuilder.control('', [Validators.required,Validators.pattern("^[a-zA-Z ]+$")]));
    this.form.addControl('dob', this.formBuilder.control('',Validators.required));
    this.form.addControl('aadharNo', this.formBuilder.control('', [Validators.required,Validators.pattern("^[2-9][0-9]{3}[ -]?[0-9]{4}[ -]?[0-9]{4}$")]));
    this.form.addControl('fatherName', this.formBuilder.control('',[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]));
    this.form.addControl('fatherMobileNo', this.formBuilder.control('',[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]));
    this.form.addControl('fatherEmailId', this.formBuilder.control('',[Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")]));
    this.form.addControl('motherName', this.formBuilder.control('',[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]));
    this.form.addControl('motherMobileNo', this.formBuilder.control('',[Validators.pattern("[1-9][0-9]{9}$")]));
    this.form.addControl('motherEmailId', this.formBuilder.control('',[Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")]));
    //this.form.addControl('mobileNo', this.formBuilder.control('',[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]));
    //this.form.addControl('emailId', this.formBuilder.control('',[Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")]));
    this.form.addControl('location', this.formBuilder.control('', [Validators.required,Validators.pattern("^[a-zA-Z ]+$")]));
    this.form.addControl('pincode', this.formBuilder.control('', [Validators.required,Validators.pattern("[1-9][0-9]{5}$")]));
    this.form.addControl('applicationFormFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('admissionFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('oneTimeFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('otherFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('otherFeeDetails', this.formBuilder.control(''));
    this.form.addControl('totalFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    
  }
  else if(this.studentTypeId ==2){
    this.form.addControl('schoolBranch', this.formBuilder.control('',Validators.required));
    this.form.addControl('studentClass', this.formBuilder.control('',Validators.required));
    this.form.addControl('studentSection', this.formBuilder.control('',Validators.required));
    this.form.addControl('registrationNo', this.formBuilder.control('', [Validators.required,Validators.pattern("^[A-Za-z0-9]+$")]));
    this.form.addControl('studentName', this.formBuilder.control('', [Validators.required,Validators.pattern("^[a-zA-Z ]+$")]));
    this.form.addControl('dob', this.formBuilder.control('', Validators.required));
    this.form.addControl('fatherName', this.formBuilder.control('',[Validators.required,Validators.pattern("^[a-zA-Z ]+$")]));
    this.form.addControl('mobileNo', this.formBuilder.control('',[Validators.required,Validators.pattern("[1-9][0-9]{9}$")]));
    this.form.addControl('emailId', this.formBuilder.control('',[Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9]+\\.[a-z]{2,4}$")]));
    this.form.addControl('reAdmissionFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('courseFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('hostelFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('transportationFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('uniformFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('examinationFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('latePaymentFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('otherFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    this.form.addControl('otherFeeDetails', this.formBuilder.control(''));
    this.form.addControl('totalFee', this.formBuilder.control('',Validators.pattern("^[0-9]*$")));
    
  }

}

getTotal() {

  this.totalFee
  if(this.studentTypeId==1)
  {
    let applicationFormFee = this.form.get('applicationFormFee').value;
    let admissionFee = this.form.get('admissionFee').value;
    let oneTimeFee = this.form.get('oneTimeFee').value;
    let otherFee = this.form.get('otherFee').value;
  

    this.totalFee =0;
    if(applicationFormFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(applicationFormFee));
    }
    if(admissionFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(admissionFee));
    }
    if(oneTimeFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(oneTimeFee));
    }
    if(otherFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(otherFee));
    }
  
  }

  if(this.studentTypeId==2)
  {
    let reAdmissionFee = this.form.get('reAdmissionFee').value;
    let courseFee = this.form.get('courseFee').value;
    let hostelFee = this.form.get('hostelFee').value;
    let transportationFee = this.form.get('transportationFee').value;
    let uniformFee = this.form.get('uniformFee').value;
    let examinationFee = this.form.get('examinationFee').value;
    let latePaymentFee = this.form.get('latePaymentFee').value;
    let otherFee = this.form.get('otherFee').value;
  
    this.totalFee =0;
    if(reAdmissionFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(reAdmissionFee));
    }
    if(courseFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(courseFee));
    }
    if(hostelFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(hostelFee));
    }
    
    if(transportationFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(transportationFee));
    }

    if(uniformFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(uniformFee));
    }

    if(examinationFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(examinationFee));
    }

    if(latePaymentFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(latePaymentFee));
    }

    if(otherFee)
    {
      this.totalFee = Number(this.totalFee +parseInt(otherFee));
    }

  }

  
 
   
  console.log("number"+this.totalFee);
    if(Number(this.totalFee)>0) 
    { 
      this.totalDisabled=false;
    }
    else{
      this.totalDisabled=true;
    }

    
    console.log(this.totalDisabled);
    this.form.updateValueAndValidity()

    this.form.controls.totalFee.setValue(this.totalFee);
    this.form.controls.totalFee.updateValueAndValidity();

}

onSubmit1():void {
  if((this.totalFee) == 0)
  {
    this.commonUtility.alertMsg('Total Fees Should Not be Zero , Please Enter Atleast One Fee Details','',false);
  }
  else{
    console.log("In Else");
    this.submitted = true;
    console.log("this.form");
    console.log(this.form);
    if (this.form.invalid) {
      console.log("Inside form");          
        return;
    }
    this.loading = true;

    var req = {};
    //let dob = +new Date((this.form.controls.dob.value))+19800000;
    //let dateAray = (new Date(dob).toISOString().split('T')[0]).split('-')
    // let dob = new Date().toISOString().split('T')[0].split('-');
    if(this.studentTypeId == 1){
      req={
        "studentType":"NEW",
        "schoolBranch": this.form.controls.schoolBranch.value.toString(),
        "studentClass": this.form.controls.studentClass.value.toString(),
        "studentName": this.form.controls.studentName.value.toString(),
        "dob": moment(this.form.controls.dob.value.toString()).format("DD-MM-YYYY"),  
        // "dob": (new Date(dob).toISOString().split('T')[0]).split('-').reverse().join('-'),
        //"dob": dateAray[1]+'-'+dateAray[2]+'-'+dateAray[0],
        "aadharNo": this.form.controls.aadharNo.value.toString(),
        "fatherName": this.form.controls.fatherName.value.toString(),
        "fatherMobileNo": this.form.controls.fatherMobileNo.value.toString(),
        "fatherEmailId": this.form.controls.fatherEmailId.value.toString(),
        "motherName": this.form.controls.motherName.value.toString(),
        "motherMobileNo": this.form.controls.motherMobileNo.value.toString(),
        "motherEmailId": this.form.controls.motherEmailId.value.toString(),
        "location": this.form.controls.location.value.toString(),
        "pincode": this.form.controls.pincode.value.toString(),
        "applicationFormFee": this.form.controls.applicationFormFee.value.toString(),
        "admissionFee": this.form.controls.admissionFee.value.toString(),
        "oneTimeFee": this.form.controls.oneTimeFee.value.toString(),
        "otherFee": this.form.controls.otherFee.value.toString(),
        "otherFeeDetails": this.form.controls.otherFeeDetails.value.toString(),
        "totalFee": this.totalFee.toString(),
        "source" : "XAVIER", 
      }  
    }else{
      req ={
        "studentType":"EXISTING",
        "schoolBranch": this.form.controls.schoolBranch.value.toString(),
        "studentClass": this.form.controls.studentClass.value.toString(),
        "studentSection": this.form.controls.studentSection.value.toString(),
        "registrationNo": this.form.controls.registrationNo.value.toString(),
        "studentName": this.form.controls.studentName.value.toString(),
        "dob": moment(this.form.controls.dob.value.toString()).format("DD-MM-YYYY"),  
        // "dob": (new Date(dob).toISOString().split('T')[0]).split('-').reverse().join('-'),  
        //"dob": dateAray[1]+'-'+dateAray[2]+'-'+dateAray[0],
        "mobileNo": this.form.controls.mobileNo.value.toString(),
        "emailId": this.form.controls.emailId.value.toString(),
        "fatherName": this.form.controls.fatherName.value.toString(),
        "reAdmissionFee": this.form.controls.reAdmissionFee.value.toString(),
        "courseFee": this.form.controls.courseFee.value.toString(),
        "hostelFee": this.form.controls.hostelFee.value.toString(),
        "transportationFee": this.form.controls.transportationFee.value.toString(),
        "uniformFee": this.form.controls.uniformFee.value.toString(),
        "examinationFee": this.form.controls.examinationFee.value.toString(),
        "latePaymentFee": this.form.controls.latePaymentFee.value.toString(),
        "otherFee": this.form.controls.otherFee.value.toString(),
        "otherFeeDetails": this.form.controls.otherFeeDetails.value.toString(),
        "totalFee": this.totalFee.toString(),
        "source" : "XAVIER", 
      }  
    }
         
    this.paymentService.submitXavierDetails(req).subscribe(res=>{

   if(res.body.statusCode === "00000")
   {
    console.log("in onSubmit1");
    this.tranxnForm.controls.EncData.setValue(res.body.data.fields.EncData);
    this.tranxnForm.controls.MerchantId.setValue(res.body.data.fields.MerchantId);
    this.tranxnForm.controls.BankId.setValue(res.body.data.fields.BankId);
    this.tranxnForm.controls.TerminalId.setValue(res.body.data.fields.TerminalId);
    this.tranxnForm.controls.Version.setValue(res.body.data.fields.Version);
    this.tranxnForm.controls.TransactionId.setValue(res.body.data.fields.TransactionId);

    this.EncDataField  	= res.body.data.fields.EncData;
    this.MerchantIdField = res.body.data.fields.MerchantId;
    this.BankIdField = res.body.data.fields.BankId;
    this.TerminalIdField = res.body.data.fields.TerminalId ;
    this.VersionField = res.body.data.fields.Version ;
   this.txnForm.nativeElement.submit();
    console.log("this.tranxnForm");
    console.log( this.tranxnForm)
    console.log( this.txnForm)

   }
   else{
    this.commonUtility.alertMsg('Please try again Failed to submit data'+res.body.statusDesc,'',false);
   }
    this.loading = false;
  },
  (error)=>{

    this.commonUtility.alertMsg('Please try again Failed to submit data','',false);
      //this.router.navigate([''])
      this.loading = false;
    });
  }
}


}
